import { ToastStatus } from '../../../../../constants/toastMessage.constants';

import { getRandom } from '../../../../../helpers/formulaHelpers';

import { getSharedLabelIds } from '../../../../../hooks/formulas/helper';

import { VariantWithLabel } from '../../../../../models/variant.model';

import { toastService } from '../../../../../services/toast.service';

export const pickRandomVariants = (
    groupedByComponent: Record<string, VariantWithLabel[]>,
    componentsByType: Record<string, Set<string>>,
    isLabeledMatchingEnabled: boolean,
): { component_id: string; variant: VariantWithLabel }[] | null => {
    const result = [];

    for (const componentIdSet of Object.values(componentsByType)) {
        const componentIds = [...componentIdSet];

        if (!isLabeledMatchingEnabled) {
            for (const cid of componentIds) {
                result.push({
                    component_id: cid,
                    variant: getRandom(groupedByComponent[cid]),
                });
            }
            continue;
        }

        const sharedLabelIds = getSharedLabelIds(
            componentIds.flatMap((cid) => groupedByComponent[cid]),
        );

        // Single component or no labelled alternates: picks freely
        if (sharedLabelIds === null) {
            for (const cid of componentIds) {
                result.push({
                    component_id: cid,
                    variant: getRandom(groupedByComponent[cid]),
                });
            }
            continue;
        }

        if (sharedLabelIds.length === 0) {
            toastService.showNotificationToast(
                ToastStatus.Warning,
                'No common label found.',
            );
            return null;
        }

        const chosenLabelId = getRandom(sharedLabelIds);

        for (const cid of componentIds) {
            const candidates = groupedByComponent[cid].filter(
                (v) => v.label?.id === chosenLabelId,
            );

            if (candidates.length === 0) return null;

            result.push({
                component_id: cid,
                variant: getRandom(candidates),
            });
        }
    }

    return result;
};
